import { render, staticRenderFns } from "./ModalInstructions.vue?vue&type=template&id=8edfa50a"
import script from "./ModalInstructions.vue?vue&type=script&lang=js"
export * from "./ModalInstructions.vue?vue&type=script&lang=js"
import style0 from "./ModalInstructions.vue?vue&type=style&index=0&id=8edfa50a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports